import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// 유저 표시 이름·사진은 setQueryData로만 저장되어 구독자가 없으므로
// 기본 gcTime(5분) 후 자동 삭제됨 → 이름이 UUID로 바뀌는 원인
// 세션 동안 유지되도록 gcTime을 Infinity로 설정
queryClient.setQueryDefaults(["userDisplay"], { gcTime: Infinity });
queryClient.setQueryDefaults(["roomPreview"], { gcTime: Infinity });
